import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CommonUtilsModule } from "../common-utils/common-utils.module";

import { StatefulContainerComponent } from "./stateful-container.component";

import { statefulContainerStatePropProvider } from "./state-props";

@NgModule({
    imports: [
        CommonModule,
        CommonUtilsModule,
    ],
    exports: [
        StatefulContainerComponent,
    ],
    declarations: [
        StatefulContainerComponent,
    ],
    providers: [
        statefulContainerStatePropProvider,
    ],
})
export class StatefulContainerModule {
}
